const CONDUCTS_QUESTIONS_FILTER_OPTIONS = {
  filter: [],
  sort: [],
};

export default CONDUCTS_QUESTIONS_FILTER_OPTIONS;
